import React from "react";
import {DisplayName, MyPlayer, Rank, Row, StreakValue} from "./styles";
import {IRankUser} from "modules/actions/leaderboards";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {IconButton} from "@mui/material";
import {useNavigate} from "react-router";
import MyPlayers from "./leaderboardRow/MyPlayers";
import {LeaderboardsTabsType, UserLeaderboardClass} from "modules";
import {OutUserType} from "components/Leaderboard/leaderboardContent/leaderboards/LeaderboardTable";
import {Exist} from "components/Exist";
import {useTranslation} from "react-i18next";

interface IProps {
	userRank: IRankUser & {page?: number | null};
	userId: number;
	ownUserRowRef?: React.MutableRefObject<HTMLLIElement | null>;
	onClickOwnUser?: () => void;
	selectedTab: LeaderboardsTabsType;
	stickyType?: OutUserType;
	isLoading: boolean;
}

const LeaderboardRow: React.FC<IProps> = ({
	userRank,
	userId,
	ownUserRowRef,
	onClickOwnUser,
	selectedTab,
	stickyType,
	isLoading,
}) => {
	const i18n = useTranslation();
	const navigate = useNavigate();
	const isOwn = userId === userRank.userId;
	const isDisabledProfile = selectedTab === LeaderboardsTabsType.AllTime;
	const isFeatured = userRank.userType === UserLeaderboardClass.Featured;
	const isHideStreak = [
		LeaderboardsTabsType.ActiveStreak,
		LeaderboardsTabsType.AllSeason,
	].includes(selectedTab);

	const goToProfile = () => {
		if (onClickOwnUser && userRank.page) {
			onClickOwnUser();
			return;
		}

		if (!isDisabledProfile) {
			navigate(`${userRank.userId}`);
		}
	};

	return (
		<Row
			position={userRank.rank}
			isOwn={isOwn}
			withBorder={!!onClickOwnUser}
			ref={isOwn ? ownUserRowRef : null}
			onClick={goToProfile}
			disabledClick={isDisabledProfile}
			isSticky={onClickOwnUser && userId === userRank.userId}
			stickyType={stickyType}
			aria-label={`${userRank.username}`}
			role={"listitem"}
		>
			<Rank aria-label={"rank"}>
				{/*<Avatar levelColor={userRank.levelColor}>*/}
				{/*	<BadgePosition className={`p_${userRank.rank}`}>*/}
				{/*		<Badge position={userRank.rank} isOwn={userId === userRank.userId} />*/}
				{/*	</BadgePosition>*/}
				{/*	<img*/}
				{/*		src={userRank.avatar || defaultAvatar}*/}
				{/*		alt={`${userRank.username}'s avatar`}*/}
				{/*	/>*/}
				{/*</Avatar>*/}
				<p>{userRank.rank}</p>
			</Rank>
			<DisplayName aria-label={"user information"}>
				<div>
					<p>{userRank.username}</p>
					{/*<p>{userRank.levelName}</p>*/}
					<Exist when={isFeatured}>
						<p className="vip">
							{i18n.t("leaderboards.table.featured_member", "Featured member")}
						</p>
					</Exist>
				</div>
			</DisplayName>

			<Exist when={!isLoading}>
				<MyPlayer>
					<MyPlayers predictions={userRank?.predictions} isHideStreak={isHideStreak} />
				</MyPlayer>
			</Exist>

			<StreakValue aria-label={"streak value"}>{userRank.streak || 0}</StreakValue>

			{!isDisabledProfile && (
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
						navigate(`${userRank.userId}`);
					}}
					aria-label={`open ${userRank.username} user id ${userId} streak ${userRank.streak} more profile detail`}
					aria-haspopup={"dialog"}
				>
					<KeyboardArrowRightIcon role={"presentation"} />
				</IconButton>
			)}
		</Row>
	);
};

export default LeaderboardRow;
